import { combineReducers } from "redux";
import { patientReducer } from "./PatientReducer";
import { surveyReducer } from "./SurveyReducer";
import { userReducer } from "./UserReducer";

const appReducer = combineReducers({
  survey: surveyReducer,
  patient: patientReducer,
  user: userReducer,
});

const rootReducer = (state, action) => {
  return appReducer(state, action);
};

export default rootReducer;
